<template>
  <router-view />
</template>

<script>
export default {
  name: 'LayoutDefault'
}
</script>